import React, { useState } from "react";
import ModalContainer from "../../common/ModalContainer";

function WheelSpinningModal({ open, setOpen }) {
  const [spinning, setSpinning] = useState(false);

  const handleSpin = () => {
    if (!spinning) {
      setSpinning(true);
      setTimeout(() => setSpinning(false), 10000); // stop after 10 seconds
    }
  };

  return (
    <ModalContainer
      open={open}
      setOpen={setOpen}
      padding="px-4 py-6"
      title={""}
      header={<></>}
      childClassname={"rounded-t-lg max-w-[600px]"}
      onClickOutside={() => setOpen(false)}
    >
      <div className="w-full flex flex-col">
        <div className="w-full">
          <div className="relative overflow-x-auto flex flex-col scroll-hide">
            <div className="flex flex-col p-4 pb-0 w-full rounded-md">
              <div className="w-full flex flex-col gap-2 items-center">
                <div className="w-full flex items-center justify-center relative">
                  <img
                    src="/wheel.svg"
                    alt=""
                    className={`w-[400px] object-contain cursor-pointer `}
                    // onClick={handleSpin}
                  />
                </div>
                <div className="w-full flex flex-col items-center justify-center text-center ">
                  <span className="font-main font-bold text-lg">
                    Flight Master Badge
                  </span>
                  <span className="text-sm text-[#6D7C94]">
                    You have booked 50 flight tickets with Intraverse!
                  </span>
                </div>
                <hr className="w-full my-4 border border-gray-200" />
                <button
                  className="w-full h-12 text-white bg-primary1 rounded-md flex items-center justify-center"
                  onClick={() => {
                    setOpen(false);
                  }}
                >
                  Got it
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
}

export default WheelSpinningModal;
